import { LoadingOutlined } from '@ant-design/icons';
import { default as Spin } from 'antd/es/spin';

const SPINNER_FONT_SIZE = {
  default: 20,
  large: 32
} as const;

type SpinnerProps = {
  className?: string;
  size?: keyof typeof SPINNER_FONT_SIZE;
};

export const Spinner = ({ className, size = 'default' }: SpinnerProps) => (
  <Spin
    indicator={
      <LoadingOutlined
        spin
        className={className}
        style={{ fontSize: SPINNER_FONT_SIZE[size] }}
      />
    }
  />
);
